import {
  GET_CARRIER_RATES,
  GET_IMPORT_HISTORY,
  GET_INTERNATIONAL_CALL_DETAILS,
  GET_TOP_DESTINATIONS,
  GET_TOP_MSISDN,
} from 'redux/admin-constants';

const INIT_STATE = {
  rates: [],
  history: [],
  callDetails: [],
  topDestinations: [],
  topMsisdns: [],
};

const analyticsReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CARRIER_RATES:
      return { ...state, rates: action.payload };
    case GET_IMPORT_HISTORY:
      return { ...state, history: action.payload };
    case GET_INTERNATIONAL_CALL_DETAILS:
      return { ...state, callDetails: action.payload };
    case GET_TOP_DESTINATIONS:
      return { ...state, topDestinations: action.payload };
    case GET_TOP_MSISDN:
      return { ...state, topMsisdns: action.payload };
    default:
      return state;
  }
};

export default analyticsReducer;
